import React, { MouseEventHandler } from 'react'

import { NavLink } from 'react-router-dom'

import { useAppDispatch, useAppSelector } from '@App/hooks'

import { MODAL_TYPES } from '@Redux/slices/modals/enums'
import { setModal } from '@Redux/slices/modals/ModalSlice'
import { isLogin } from '@Redux/slices/user/UserSlice'

import {
  MARGIN_TYPE,
  ORDER_ACTION_TYPE,
} from '@UI/crypto_exchange/desktop/pages/spot/components/SpotOrderTrade/components/types'
import { ROUTE_NAMES } from '@UI/crypto_exchange/desktop/routes/routeNames'

import classes from './TradeOrderConfirmBtn.module.scss'

interface ITradeOrderConfirmBtnProps {
  type: ORDER_ACTION_TYPE
  activeMarginTab: MARGIN_TYPE | ''
  source_currency: string
  target_currency: string
  sendMessage: MouseEventHandler<HTMLButtonElement>
  children?: React.ReactNode
  disabled?: boolean
}

export const TradeOrderConfirmBtn = ({
  type,
  activeMarginTab,
  source_currency,
  target_currency,
  sendMessage,
  disabled,
  children,
}: ITradeOrderConfirmBtnProps) => {
  const dispatch = useAppDispatch()
  const is_login = useAppSelector(isLogin)
  const getButtonTitle = () => {
    switch (activeMarginTab) {
      case MARGIN_TYPE.BORROW:
        return `Margin ${type} ${source_currency}`
      default:
        return `${type}`
    }
  }

  return (
    <>
      {is_login ? (
        <button
          className={`${classes.btn} ${classes[type]} ${disabled && classes.disabled}`}
          onClick={sendMessage}
          disabled={disabled}
        >
          {children ? children : getButtonTitle()}
        </button>
      ) : (
        <div className={classes.authButton}>
          <div onClick={() => dispatch(setModal({ modalType: MODAL_TYPES.LOGIN_MODAL }))} className={classes.authLink}>
            Log In
          </div>
          &nbsp; or &nbsp;
          <div onClick={() => dispatch(setModal({ modalType: MODAL_TYPES.REGISTRATION_MODAL }))} className={classes.authLink}>
            Register Now
          </div>
        </div>
      )}
    </>
  )
}
